<template>
    <div class="all">
        <div class="content">
            <div class="content-nav">
                <div class="nav-content flex-column">

                    <el-tooltip placement="left" effect="light">
                        <div slot="content">
                            <img style="width: 140px; height: 140px;" src="@/assets/sidebar/kefu.png" alt="" />
                        </div>
                        <div class="nav-item flex-column flex-center">
                            <img style="width: 38px; height: 34px;" src="@/assets/sidebar/service.png" alt="" />
                            在线咨询
                        </div>
                    </el-tooltip>

                    <el-tooltip placement="left" effect="light">
                        <div slot="content" class="tooltip-content miniApp flex-column">
                            <div>18660122326</div>
                        </div>

                        <div class="nav-item flex-column flex-center">
                            <img style="width: 37px; height: 32px;" src="@/assets/sidebar/phone.png" alt="" />
                            合作专线
                        </div>
                    </el-tooltip>
                    <div class="nav-item flex-column flex-center" @click="toOpen()">
                        <img style="width: 47px; height: 32px;" src="@/assets/sidebar/experience.png" alt="" />
                        体验产品
                    </div>
                    <el-tooltip placement="left" effect="light">
                        <div slot="content" class="tooltip-content miniApp flex-column">
                            <img :src="qrCode" />
                            <div>微信扫一扫</div>
                        </div>
                        <div class="nav-item nav-item2 flex-column flex-center">
                            <img style="width: 32px; height: 32px;" src="@/assets/sidebar/attention.png" alt="" />
                            关注我们
                        </div>
                    </el-tooltip>
                </div>
            </div>
            <div class="receive" @click="toOpen">
                <!-- <img class="receive2 " src="@/assets/home/receive2.png" alt="" /> -->
                <img :class="[{ animated: isActive }, { shake: isActive2 }, 'receive1']" style=""
                    src="@/assets/home/receive2.png" alt="" />
            </div>
        </div>

    </div>
</template>
<script src="https://yzf.qq.com/xv/web/static/chat_sdk/yzf_chat.min.js"></script>
<script>
export default {
	data() {
		return {
			isSdkReady: false,
			qrCode: require('@/assets/complianceStudy/QRCode1.png'),
			oldScrollTop: 0,
			isActive:false,
			isActive2:false,
		};
	},
	methods: {
		toOpen() {
			this.$router.push('/freeTrial');
		},
		tokefu() {
            window.open('https://work.weixin.qq.com/kfid/kfc7886e89e62bf9a71');

		},
		toPerson() {},
		backtop() {
			let top = document.documentElement.scrollTop || document.body.scrollTop;
			// 实现滚动效果
			const timeTop = setInterval(() => {
				document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
				if (top <= 0) {
					clearInterval(timeTop);
				}
			}, 20);
		},
		scrolling() {
			// 滚动条距文档顶部的距离
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			// 滚动条滚动的距离
			let scrollStep = scrollTop - this.oldScrollTop;
			// 更新——滚动前，滚动条距文档顶部的距离
			this.oldScrollTop = scrollTop;
			//变量windowHeight是可视区的高度
			let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
			//变量scrollHeight是滚动条的总高度
			let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
			
			// console.log(scrollStep)
			//滚动条到底部的条件
			if (scrollTop + windowHeight == scrollHeight) {
				this.scrollStatus = true;
				//你想做的事情
			}
			// console.log(this.oldScrollTop)
			if(this.oldScrollTop>=500 &&this.oldScrollTop<=1500  || this.oldScrollTop>=2500 &&this.oldScrollTop<=3500){
			this.isActive=true
			this.isActive2=true
			}else{
			this.isActive=false
			this.isActive2=false
			}
			//滚动条向上滚动
			if (scrollStep < 0) {
			} else {
			}
			// 判断是否到了最顶部
			if (scrollTop <= 0) {
			}
			if (scrollTop - 150 <= 0) {
			}
		},
	},
	
	mounted() {
		window.addEventListener('scroll', this.scrolling);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.scrolling);
	},
	
};
</script>

<style lang="scss" scoped>
.tooltip-content {
	font-size: $global-font-size-20;
	color: #666666;

	img {
		width: 100px;
		height: 100px;
	}
}

.miniApp {
	align-items: center;
	font-size: $global-font-size-14;

	img {
		margin-bottom: 10px;
	}
}


.content {
	position: fixed;
	z-index: 9999;
	right: 21px;
	top: 45%;

	.content-nav {
		width: 65px;
		border-radius: 16px;

		.nav-content {
			height: 281px;
			justify-content: space-between;
			box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
			background: #ffffff;
			border-radius: 12px;
			overflow: hidden;

			.nav-item2 {
				background: #2970ec !important;
				color: #ffffff !important;
			}

			.nav-item {

				height: 70px;
				font-size: 12px;
				align-items: center;
				cursor: pointer;
				border-radius: 3px;
				color: #2970ec;

				img {
					margin-bottom: 4px;
				}
			}
		}
	}

	.receive {
		margin-top: 20px;
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.receive:hover {

		.receive1 {
			transition: all 1s;
		}
	}

	.receive1 {
		width: 250px;
		height: 70px;
		position: absolute;
		right: -10px;
		top: 10px;
		cursor: pointer;
	}

	// .receive2 {
	// 	transition: all 0.3s;
	// 	background-image: url('../../../assets/home/receive2.png');
	// 	background-repeat: no-repeat;
	// 	background-size: 100% 100%;
	// 	width: 0px;
	// 	position: absolute;
	// 	right: 0;
	// 	height: 70px;
	// }
	.content-UpTop {
		margin-top: 11px;
		justify-content: center;
		cursor: pointer;
	}
}
</style>
